export default __webpack_public_path__ + "static/media/060_corner2.hevc.5639b3c6.mp4";